export default __webpack_public_path__ + "static/media/greece.cc789de5.svg";